import { useContext } from 'react'

import ArticleBodyContentContext from '@contexts/articleBodyContent'

const useIsInArticleBodyContent = (): boolean =>
  !!useContext(ArticleBodyContentContext)

export default useIsInArticleBodyContent
